
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/to/[to]/[id]",
      function () {
        return require("private-next-pages/admin/to/[to]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/to/[to]/[id]"])
      });
    }
  